<template>
<div>
  <header class="titleRow">
    <div class="row">
      <div class="col-sm-2">
          <h4>Jobs</h4>
      </div>
      <div class="col-sm-5">
        <input type="text" v-model="keywordSearch" v-on:keyup.enter="searchOrders" placeholder="Search by name, company or reference ..." />
      </div>
      <div class="col-sm-5">
        <div align="right">
          <router-link to="/jobs/new" class="btnGreenHeader" style="margin-top: -3px; margin-right: 10px">Create New Job</router-link>
        </div>
      </div>
      <div class="col-sm-1">
         
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <ul class="filterNav filterNavBottom">
          <router-link :to="{name: 'Orders'}"><li>All</li></router-link>
          <router-link :to="{name: 'Orders', query:{type: 'active'}}"><li>Active</li></router-link>
          <router-link :to="{name: 'Orders', query:{type: 'processing'}}"><li>Processing</li></router-link>
          <router-link :to="{name: 'Orders', query:{type: 'further'}}"><li>Further Work</li></router-link>
          <router-link :to="{name: 'Orders', query:{type: 'complete'}}"><li>Complete</li></router-link>
        </ul>
      </div>
    </div>
  </header>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="row">
      <div class="col-sm-12">
        <div id="resultsHeader">
          <div class="checkboxCol"></div>
          <div class="iconCol"></div>
          <div class="smallCol">Job No</div>
          <div class="smallCol">Type</div>
          <div class="doubleCol">Company</div>
          <div class="normalCol">Status</div>
          <div class="smallCol">Invoiced</div>
          <div class="smallCol">Date</div>
        </div>
      </div>
    </div>
    <div class="row" v-for="order in orders" :key="order.id">
      <div v-if="order.type=='Job'">
        <router-link :to="{name: 'OrdersEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol">
              <div align="center">
                <input type="checkbox" name="checkbox" />
              </div>
            </div>
            <div class="iconCol"></div>
            <div class="smallCol">{{ order.order_number }}</div>
            <div class="smallCol">Job</div>
            <div class="doubleCol">{{ order.name }}</div>
            <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
            <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
            <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
      <div v-if="order.type=='Refrigeration Maintenance'">
        <router-link :to="{name: 'OrdersRefridgerationEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol">
              <div align="center">
                <input type="checkbox" name="checkbox" />
              </div>
            </div>
            <div class="iconCol"></div>
            <div class="smallCol">{{ order.order_number }}</div>
            <div class="smallCol">Refrigeration Checklist</div>
            <div class="doubleCol">{{ order.name }}</div>
            <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
            <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
            <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
      <div v-if="order.type=='Maintenance'">
        <router-link :to="{name: 'MaintenanceEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol">
              <div align="center">
                <input type="checkbox" name="checkbox" />
              </div>
            </div>
            <div class="iconCol"></div>
            <div class="smallCol">{{ order.order_number }}</div>
            <div class="smallCol">Large Maintenace</div>
            <div class="doubleCol">{{ order.name }}</div>
            <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
            <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
            <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
      <div v-if="order.type=='Air Con'">
        <router-link :to="{name: 'OrdersAirconEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol">
              <div align="center">
                <input type="checkbox" name="checkbox" />
              </div>
            </div>
            <div class="iconCol"></div>
            <div class="smallCol">{{ order.order_number }}</div>
            <div class="smallCol">Air Con</div>
            <div class="doubleCol">{{ order.name }}</div>
            <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
            <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
            <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
    </div>
  </div>
  <div class="paginationSpacer"></div>
  <div class="paginationContainer">
    <div class="row">
      <div class="col-sm-12">
        <div align="right">
          Showing page {{ pagination.current_page }} of {{ pagination.last_page }} <a class="btnPaginate" @click.prevent="getOrders(pagination.prev_page_url)">Previous</a> <a class="btnPaginate" @click.prevent="getOrders(pagination.next_page_url)">Next</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      orders: {},
      pagination: {},
      keywordSearch: []
    }
  },
  created () {
    this.getOrders(),
    this.$watch(
      () => this.$route.query,
      (toParams, previousParams) => {
        this.getOrders (this.page)
      }
    )
  },
  methods: {
    getOrders (page) {
      if (typeof page === 'undefined') {
        page = '/api/orders?page=1'
      }
      var pageFilter = this.$route.query.type
      var pageGet = page + '&type=' + pageFilter
      axios
        .get(pageGet)
        .then((res) => {
          this.orders = res.data.data
          this.pagination = res.data
        })
    },
    searchOrders () {
      const keywords = { keywords: this.keywordSearch }
      axios
        .post('/api/orders/search', keywords)
        .then(response => {
          this.orders = response.data.data
          this.pagination = response.data
        })
    }
  }
}
</script>
